
angular.module('bmsApp.directives').factory('ProximitySvc', [
	'$q',
	'$rootScope',
	'$modal',
	'notify',
	'CRUDSvc',
	'PROXIMITY_API', function (
		$q,
		$rootScope,
		$modal,
		notify,
		CRUDSvc,
		PROXIMITY_API) {

	return {
		showLocatorModal: function (license, postcode, durationInMinutes) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/global/proximity/templates/ProximityInfoModal.html',
				controller: 'ProximityInfoModalCtrl',
				size: 'lg',
				scope: $rootScope,
				resolve: {
					license: function () {
						return angular.copy(license);
					},
					postcode: function () {
						return angular.copy(postcode);
					},
					durationInMinutes: function () {
						return angular.copy(durationInMinutes);
					},
				}
			});
			return modalInstance.result;
		},
		nearByRoutes: function (params) {
			return CRUDSvc.get(PROXIMITY_API.NEARBY_ROUTES, params);
		},

	};

}]).constant('PROXIMITY_API', {
	NEARBY_ROUTES: 'api/proximity/nearby-routes',
});
